import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Autocomplete from '@mui/material/Autocomplete';
import styles from "./CountrySelect.module.scss";
import TextField from '@mui/material/TextField';
import {withStyles} from '@mui/styles';
import {store} from "./../../app/store";
import {useSelector} from "react-redux";
import {selectMediakitUser, setMediakitUser} from "./../../features/stores/mediakitUser.slice";
import {setDataChange} from "./../../features/stores/changeData.slice";
import {countries} from "../../constants/countries";
import Box from '@mui/material/Box';

interface ICountry {[key: string]: string}[];

const CssTextField = withStyles({
    root: {
      '& .MuiOutlinedInput-root': {
        'fontSize': '16px',
        '& .MuiChip-root': {
          height: 'fit-content',
          minHeight: '32px',
        },
        '& .MuiChip-label': {
          whiteSpace: 'break-spaces',
          fontSize: '16px',
        },
        '& fieldset': {
          borderRadius: '30px',
        },
        '&:hover fieldset': {
          border: '1px solid #208CED',
        },
        '&.Mui-focused fieldset': {
          border: '1.5px solid #208CED',
        },
        '&input:focus-visible': {
          border: 'none',
        },
      },
    },
  })(TextField);

type Props = {};

const CountrySelect: React.FC<Props> = ()=> {
  const {t, i18n} = useTranslation();
  const mediakitUser = useSelector(selectMediakitUser);
  const getUserLocations = (locationString?: string) => {
    const locationTmp = locationString? locationString : mediakitUser?.country;
    const locations = locationTmp?.replace(/,\s/gm, ',').split(',');
    const temp: ICountry[] = [];
    locations?.map((userCountry: string) => {
      const found = countries.find((country: ICountry) => {
        return userCountry === country.label;
      });
      if (found) {
        temp.push(found);
      }
    });
    return temp;
  };
  const [selectedCountries, setSelectedCountries] = useState<any>([]);
  const countryToFlag = (isoCode: string) => {
    return typeof String.fromCodePoint !== 'undefined' ?
      isoCode
          .toUpperCase()
          .replace(/./g, (char) =>
            String.fromCodePoint(char.charCodeAt(0) + 127397),
          ) :
      isoCode;
  };
  const handleChangeInputValue = (e: any, nv: any) => {
    setSelectedCountries(nv?.length ? [nv[nv?.length - 1]] : []);
    store.dispatch(setMediakitUser({...mediakitUser, country: nv?.length ? nv[nv?.length - 1].label : ''}));
    store.dispatch(setDataChange(true));
  };
  useEffect(() => {
    if (mediakitUser?.country) {
      setSelectedCountries(getUserLocations());
    }
  }, [mediakitUser?.country]);
  return (
      <Autocomplete
          key={`autocomplete-locations-${selectedCountries}`}
          multiple
          id="tags-outlined"
          options={countries}
          role="combobox"
          className={styles.autocomplete}
          getOptionLabel={(option) => option.label || ''}
          filterSelectedOptions
          style={{border: 'none', width: '100%'}}
          renderOption={(props, option) => (
                <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...props}>
                  <span className={styles.option_flag}>
                    {countryToFlag(option.code)}
                   </span>
                  {option.label}
                </Box>
          )}
          onChange={(e, nv) => {
              handleChangeInputValue(e, nv);
          }}
          renderInput={(params) => (
              <CssTextField
                  {...params}
                  id="custom-css-outlined-input"
                  variant="outlined"
                  placeholder={t("country_placeholder")}
              />
          )}
          value={selectedCountries}
      />
  );
};

export default CountrySelect;
